<template>
  <div class="card">
    <div class="card-header">
      Details for {{ value.firstName ? value.firstName : 'Student' }}
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-sm-3" v-for="(property, field) in fields">
          <template v-if="field == 'classId'">
            <label class="font-weight-bold">{{ labels['classId'] }}</label>
            <div>{{ className }}</div>
          </template>

          <template v-else-if="field == 'gender'">
            <label class="font-weight-bold">{{ labels['gender'] }}</label>
            <div>{{ gender }}</div>
          </template>

          <template v-else-if="field == 'exemption'">
            <label class="font-weight-bold">{{ labels['exemption'] }}</label>
            <div>{{ exemption }}</div>
          </template>

          <template v-else>
            <label class="font-weight-bold">{{ labels[field] }}</label>
            <div>{{ value[field] }}</div>
          </template>
        </div>
      </div>

      <div class="text-right mt-sm-2">
        <button type="button" class="btn btn-sm btn-outline-secondary" data-dismiss="modal" v-on:click="cancel()">
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: [
      'value',
      'editing',
      'labels',
      'fields',
      'classes',
      'genders',
      'exemptions',
      'school'
    ],
    computed: {
      className: function() {
        return _.get(_.get(this.classes, this.value + '.classId'), 'name');
      },
      gender: function() {
        return _.get(this.genders, this.value + '.gender');
      },
      exemption: function() {
        return _.get(this.exemptions, this.value + '.exemption');
      }
    },
    methods: {
      cancel: function() {
        this.$emit('cancel');
      }
    }
  }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/view-student.vue